module.exports = __webpack_public_path__ + "img/handraw_selection.91e4d293.svg";